import { createAction } from 'redux-actions';
import { MenuItem } from '../contentful/contentfulClient';

export enum MenuActionType {
    DATA_LOAD_START = 'MENU:DATA_LOAD_START',
    DATA_LOADING = 'MENU:DATA_LOADING',
    DATA_LOAD_SUCCESS = 'MENU:DATA_LOAD_SUCCESS',
    DATA_LOAD_FAILED = 'MENU:DATA_LOAD_FAILED',
    BAR_EXPANDED = 'MENU:BAR_EXPANDED'
}

const menuDataLoadStartAction = createAction(MenuActionType.DATA_LOAD_START);
const menuDataLoadingAction = createAction(MenuActionType.DATA_LOADING);
const menuDataLoadSuccessAction = createAction<Array<MenuItem>>(MenuActionType.DATA_LOAD_SUCCESS);
const menuDataLoadFailedAction = createAction<Error>(MenuActionType.DATA_LOAD_FAILED);

const menuBarToggled = createAction<boolean>(MenuActionType.BAR_EXPANDED);

export const menuActions = {
    menuDataLoadStartAction,
    menuDataLoadingAction,
    menuDataLoadSuccessAction,
    menuDataLoadFailedAction,
    menuBarToggled
};



// WEBPACK FOOTER //
// ./src/menu/MenuActions.ts